import { useMutation } from '@apollo/client';
import { DELETE_LEARNING_OBJECT_MUTATION } from '../../mutations';

export function useDeleteLearningObjectMutation() {
    return useMutation( DELETE_LEARNING_OBJECT_MUTATION );
}
